<template>
	<div>
		<div class="row top">
			<div class="col-sm-6">

				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<label class="lebeltop">%</label>

					<b-form-input style="width: 100%"
								  size="sm"
								  type="number"
								  id="percentage"
								  v-model="itemLocal.percentage"
								  :disabled="disabledDiscountType"
								  ref="percentageOptomRef"
								  v-on:keyup.enter="submitWithEnter"
					/>
				</b-form-group>
			</div>
			<div class="col-sm-6">
				<b-form-group
					label-size="sm"
					class="required"
					label-for="lastName">
					<label class="lebeltop">Сумма (-)</label>
					<b-form-input size="sm"
								  type="number"
								  id="fixed"
								  v-model="itemLocal.fixed"
								  :disabled="disabledDisCountAmount"
								  ref="fixedOptomRef"
								  v-on:keyup.enter="submitWithEnter"
					/>
				</b-form-group>
			</div>

		</div>
		<div class="row top mt-3 justify-content-end">
			<div class="col-4">
				<b-button variant="outline-danger" size="sm" block
						  @click="closeModal">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-4">
				<b-button variant="outline-success" size="sm" block @click="saveSubmit">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>
	</div>

</template>

<script>
	import {mapGetters, mapState} from "vuex";

	export default {
		name: "PosDiscountOptom",
		props:['canceled'],
		data() {
			return {
				itemLocal: {
					fixed: '',
					percentage: ''
				},
				promoType: null,
			}
		},
		methods: {
			closeModal() {
				this.$emit("emitClose", false);
			},
			changeDefault(){
				this.itemLocal ={
					fixed: '',
					percentage: ''
				}
			},
			async submitWithEnter() {
				await    this.saveSubmit();
				await this.$emit("emitClose", false);
			},
			async saveSubmit(type,discount) {

				let discountType = {
					setToNull: false,
				};
				if (this.itemLocal.percentage != '') {
					discountType.promotionType = "%";
					this.promoType = "%"
					discountType.discount = this.itemLocal.percentage;

				}
				if(this.itemLocal.fixed != ''){
					discountType.promotionType = 'PUL';
					this.promoType = "PUL"
					discountType.discount = this.itemLocal.fixed;
				}

				if(this.itemLocal.percentage === '' && this.itemLocal.fixed === ''){
					discountType.promotionType = this.promoType;
					discountType.discount = 0;
					discountType.setToNull = true;
				}
				this.$emit('saveSuccess',discountType)
			},
		},
		watch:{
			canceled: {
				handler(newValue){
					if(newValue){
						this.changeDefault()
					}
				}
			},
		},
		computed: {
			disabledDisCountAmount() {
				return this.itemLocal.percentage !== '';
			},
			disabledDiscountType() {
				return this.itemLocal.fixed !== '';
			},
			...mapGetters('pos', [
				'getItems', 'getCartItems', 'getDiscountItemForModal'
			]),
			...mapState('pos', [
				'saleItemForDiscountModal', 'currentSaleId'
			]),

		}
	}

</script>

<style scoped>

</style>
